import centreLocator from "./centre-locator.vue";
import slotSelector from "./slot-selector.vue";
import studentDetails from "./student-details.vue";
import Vuelidate from "vuelidate";
import Vue from "vue/dist/vue.js";
import VueRouter from "vue-router";
import axios from "axios";
import { trackBookingStart } from "./tracking";

Vue.use(Vuelidate);
Vue.use(VueRouter);

new Vue({
  el: "#app",
  components: {
    centreLocator: centreLocator,
    slotSelector: slotSelector,
    studentDetails: studentDetails
  },
  router: new VueRouter({
    mode: "history",
    routes: []
  }),
  data: {
    countryCode: bookingCountryRestrict,
    selectedCentre: null,
    selectedTime: null,
    lead: false,
    slotType: "O",
    centreLocationId: 0,
    superCentreId: null,
    campaignId: 0,
    isCorporate: false,
    inCentreFirst: [290, 537, 561, 322, 861, 931, 975, 161]
  },
  validations: {},
  watch: {
    selectedCentre: function() {
      // trigger if and only if centre is set
      if (this.selectedCentre) {
        // This will ensure if any direct centre id coming in,
        // if the id is greater than defined limit,
        // update it to the default direct centre id for api's.
        if(+this.selectedCentre.id >= +dummyDirectCentreId) {
          this.selectedCentre.id = directCentreId;
          this.selectedCentre.phone = this.selectedCentre.centrePhone;
        }
        this.superCentreId = this.selectedCentre.id;
        this.$refs.slotSelector.init();
        this.$refs.studentDetails.init();
      }
    },
    slotType: function() {
      this.$refs.slotSelector.selectedSlot = null;
      this.$refs.slotSelector.selectedIndex = null;
    }
  },
  mounted: function() {
    var selectedCentre = JSON.parse(sessionStorage.getItem("bookedCentre"));
    if (selectedCentre) {
      this.selectedCentre = selectedCentre;
      this.isCorporate = selectedCentre.isCorporate;
    }

    if (this.$route.query.isInCentre) {
      this.slotType = 'C';
    }

    this.campaignId = this.getCampaignIdFromQueryString();
    var self = this;
    var triggerStartOnInteraction = function(e) {
      if (e && e.isTrusted === false) return;
      if (e && e.type === 'keydown' && (e.ctrlKey || e.metaKey || e.key === 'F5' || e.key === 'Control' || e.key === 'Meta' || e.key === 'Alt')) return;

      trackBookingStart({
        countryCode: bookingCountryRestrict,
        campaignId: self.campaignId,
        selectedServiceType: self.slotType === 'O' ? 'online' : (self.slotType === 'C' ? 'in_centre' : null)
      });
      document.removeEventListener("focusin", triggerStartOnInteraction);
      document.removeEventListener("click", triggerStartOnInteraction);
      document.removeEventListener("keydown", triggerStartOnInteraction);
      document.removeEventListener("touchstart", triggerStartOnInteraction);
    };

    document.addEventListener("focusin", triggerStartOnInteraction);
    document.addEventListener("click", triggerStartOnInteraction);
    document.addEventListener("keydown", triggerStartOnInteraction);
    document.addEventListener("touchstart", triggerStartOnInteraction);

    if(this.$route.query.isOnline && !this.$route.query.centreId) {
      axios.get("centres.json").then(response => {
        var centres = response.data;
        var selectedCentre = centres.find(
          centre => centre.name === 'Online');
        if (selectedCentre) {
          this.selectedCentre = selectedCentre;
          this.isCorporate = selectedCentre.isCorporate;
        }
      });
    }

    if (this.$route.query.centreId) {
      axios.get("centres.json").then(response => {
        var centres = response.data;
        var selectedCentre = centres.find(
          centre => +centre.id === +this.$route.query.centreId
        );
        if (selectedCentre) {
          this.selectedCentre = selectedCentre;
          this.isCorporate = selectedCentre.isCorporate;
        }
      });
    }
  },
  methods: {
    reset: function() {
      if (typeof window !== "undefined") {
        window.__kipFallbackFormStarted = false;
      }
      this.selectedCentre = null;
      this.selectedTime = null;
      this.lead = false;
      this.slotType = "C";
      this.centreLocationId = 0;
      this.superCentreId = null;
      this.$refs.slotSelector.reset();
      if (this.$refs.studentDetails != undefined) {
        this.$refs.studentDetails.reset();
      }
    },
    getCampaignIdFromQueryString() {
      const campaign = this.$route.query.campaign;
      return (campaign) ? campaign : 0;
    }
  }
});
